/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PublicService {

    /**
     * @param filterMunicipalities
     * @param filterCountry
     * @param filterObjTypeName
     * @param filterSold
     * @param filterPublishOnNet
     * @param filterPropertyDescription
     * @param filterSortBy
     * @param filterOfficeIds
     * @param filterRegionIds
     * @param filterImagesExists
     * @param listStart
     * @param listNumber
     * @returns any Success
     * @throws ApiError
     */
    public static publicSearchObjects(
        filterMunicipalities?: string,
        filterCountry?: string,
        filterObjTypeName?: string,
        filterSold?: string,
        filterPublishOnNet?: string,
        filterPropertyDescription?: string,
        filterSortBy?: string,
        filterOfficeIds?: string,
        filterRegionIds?: string,
        filterImagesExists?: string,
        listStart?: string,
        listNumber?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Public/SearchObjects',
            query: {
                'FilterMunicipalities': filterMunicipalities,
                'FilterCountry': filterCountry,
                'FilterObjTypeName': filterObjTypeName,
                'FilterSold': filterSold,
                'FilterPublishOnNet': filterPublishOnNet,
                'FilterPropertyDescription': filterPropertyDescription,
                'FilterSortBy': filterSortBy,
                'FilterOfficeIds': filterOfficeIds,
                'FilterRegionIds': filterRegionIds,
                'FilterImagesExists': filterImagesExists,
                'ListStart': listStart,
                'ListNumber': listNumber,
            },
        });
    }

    /**
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    public static publicGetObject(
        id?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Public/GetObject',
            query: {
                'id': id,
            },
        });
    }

    /**
     * @param filterOfficeIds
     * @param viewingsFrom
     * @returns any Success
     * @throws ApiError
     */
    public static publicEstatesWithViewings(
        filterOfficeIds?: string,
        viewingsFrom?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Public/EstatesWithViewings',
            query: {
                'filterOfficeIds': filterOfficeIds,
                'viewingsFrom': viewingsFrom,
            },
        });
    }

    /**
     * @param email
     * @returns any Success
     * @throws ApiError
     */
    public static publicGetComissionForBroker(
        email?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Public/GetComissionForBroker',
            query: {
                'email': email,
            },
        });
    }

    /**
     * @returns any Success
     * @throws ApiError
     */
    public static publicGetTopTenComissions(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Public/GetTopTenComissions',
        });
    }

}
